export default "__VITE_ASSET__CA_aU$_q__"